(function () {
  'use strict';

  function init() {
    initFaq();
    initSliders();
    initCompare();
    initKlaviyo();
  }

  // ---------- Klaviyo popup triggers ----------
  function initKlaviyo() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-klaviyo-form]'));
    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var formId = el.getAttribute('data-klaviyo-form');
        if (!formId) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });
  }

  // ---------- FAQ accordion ----------
  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.lpc-faq__item'));
    items.forEach(function (item) {
      var btn = item.querySelector('.lpc-faq__q');
      var panel = item.querySelector('.lpc-faq__a');
      if (!btn || !panel) return;

      function setOpen(open) {
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      }

      // Honour any item that should start expanded.
      setOpen(item.classList.contains('is-open'));

      btn.addEventListener('click', function () {
        setOpen(!item.classList.contains('is-open'));
      });
    });

    // Recompute heights of open panels on resize so wrapped text isn't clipped.
    window.addEventListener('resize', function () {
      document.querySelectorAll('.lpc-faq__item.is-open .lpc-faq__a').forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  // ---------- Generic fade sliders ----------
  function initSliders() {
    var sliders = Array.prototype.slice.call(document.querySelectorAll('.lpc-slider'));
    sliders.forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.lpc-slide'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('.lpc-slider__dot'));
      var prev = slider.querySelector('.lpc-slider__arrow--prev');
      var next = slider.querySelector('.lpc-slider__arrow--next');
      if (slides.length < 2) return;

      var idx = 0;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }

      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { go(i); });
      });

      if (slider.getAttribute('data-autoplay') !== 'false') {
        setInterval(function () { go(idx + 1); }, 5000);
      }
    });
  }

  // ---------- Before / after comparison ----------
  function initCompare() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('.lpc-ba'));
    widgets.forEach(function (ba) {
      var handle = ba.querySelector('.lpc-ba__handle');
      var dragging = false;

      function setPos(clientX) {
        var rect = ba.getBoundingClientRect();
        if (!rect.width) return;
        var p = ((clientX - rect.left) / rect.width) * 100;
        p = Math.max(0, Math.min(100, p));
        ba.style.setProperty('--pos', p + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
      }

      ba.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { ba.setPointerCapture(e.pointerId); } catch (err) {}
        setPos(e.clientX);
      });
      ba.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      function stop() { dragging = false; }
      ba.addEventListener('pointerup', stop);
      ba.addEventListener('pointercancel', stop);

      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var cur = parseFloat(ba.style.getPropertyValue('--pos')) || 50;
          if (e.key === 'ArrowLeft') { ba.style.setProperty('--pos', Math.max(0, cur - 5) + '%'); e.preventDefault(); }
          else if (e.key === 'ArrowRight') { ba.style.setProperty('--pos', Math.min(100, cur + 5) + '%'); e.preventDefault(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            handle.setAttribute('aria-valuenow', Math.round(parseFloat(ba.style.getPropertyValue('--pos'))));
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
